import { MergedPriceAndAvailabilityResponse } from 'services/dealerPriceAvailability/types';
import {
  AlternateCurrentObject,
  AlternateObject,
  RelatedPartsPriceObject
} from 'services/product/types';

export const mergeFitmentResponseData = async (
  productAlternateParts: AlternateObject[],
  dataFitment: ProductFitmentResponse,
  partNumber: string,
  data: AlternateCurrentObject
) => {
  const mergedAltPartsResponse = productAlternateParts.map((product) => {
    if (dataFitment?.[product.partNumber]) {
      return { ...product, ...dataFitment[product.partNumber] };
    }
    return product;
  });

  const { isSerialRangeCompatible = false, isSerialCompatible = false } =
    dataFitment?.[`${partNumber}`] || {};

  const newData = {
    ...data,
    merchandisingAssociations: mergedAltPartsResponse,
    isSerialRangeCompatible,
    isSerialCompatible
  };

  return { productAlternateParts, mergedAltPartsResponse, newData };
};

export const mergeFitmentData = async (
  relatedParts: RelatedPartsPriceObject[],
  dataFitment: ProductFitmentResponse
) => {
  const mergedAllPartsResponse = relatedParts.map((product) => {
    if (dataFitment?.[product.partNumber]) {
      return { ...product, ...dataFitment[product.partNumber] };
    }
    return product;
  });
  return { mergedAllPartsResponse };
};

export const getProductWithPartNumber = (
  partNumber: string,
  priceAndAvailability: MergedPriceAndAvailabilityResponse[]
): MergedPriceAndAvailabilityResponse | undefined => {
  return priceAndAvailability?.find((item) => item.partNumber === partNumber);
};
